import { SharedService } from './../../services/shared.service';
import { FiltersService } from 'app/components/filters/filters.service';

import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { ProductsService } from 'app/components/products/products.service';
import { CatalogueService } from 'app/components/catalogue/catalogue.service';
import { SessionService } from 'app/components/common/session/session.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ExhitorsService } from 'app/components/exhitors/exhitors.service';
import { SearchService } from 'app/components/search/search.service';
import { UtilsService } from 'app/components/utils/utils.service';
import { TranslateService } from '@ngx-translate/core';
import { DetailsService } from 'app/components/details/details.service';
import { EmailModalComponent } from 'app/components/email-modal/email-modal.component';
import { LoginService } from 'app/components/login/login.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MatDialog } from '@angular/material/dialog';
import { ModalLoginComponent } from 'app/components/modal-login/modal-login.component';
import {ModalSimpleComponent} from "app/components/modal-simple/modal-simple.component";
import { ENV } from '../../../environments/environment';
import { Title } from '@angular/platform-browser';
import { AnalyticsService } from 'app/components/analytics/analytics.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'card-detail-product',
  templateUrl: './card-detail-product.component.html',
  styleUrls: ['./card-detail-product.component.scss']
})
export class CardDetailProductComponent implements OnInit, OnDestroy {
  
  //@Input() images: any[] = [];
  //@Input() categories: any;
  @Input() exhibitor: any;
  //@Input() product: any;
  @Input() isFavorite: boolean = false;
  //@Input() socialNetworks: any[] = [];
  //@Input() files: any[] = [];
  @Input() videoEmbed: string = '';
  @Input() mapsActive: boolean = false;
  @Input() eventData: any;

  activeImage: any;
  catalogueProperties: any = {};

  sub;
  unifiedCategories: any = [];
  searchConfig;
  productId;
  catalogueId;
  exhibitorId;
  productDetail: any = {};

  products: any[] = [];
  projection: any = {};
  productsDetail: any[] = [];
  productWithExhibitorData: any[] = [];

  loader: any = {
    count: 0
  };
  alertType: string = '';
  alertMessage: string = '';

  anonymousEmailAllowed: boolean = false;

  type:string = 'PRODUCT';

  data: any;
  images;
	productCategories;
	hierarchicalProperties;
	files = [];
	socialNetworks;
	imageUrl;

  eventName;

  first:boolean = false;
  mobile: boolean = false;

  private langChangeSubscription: Subscription;

  constructor(public sessionService: SessionService, private activatedRoute:ActivatedRoute,private exhitorsService:ExhitorsService, 
    public catalogueService:CatalogueService, private productsService:ProductsService, private searchService:SearchService,
    public utilsService:UtilsService, private router:Router, public translateService: TranslateService, public detailsService:DetailsService, 
    private modalService: NgbModal, public loginService:LoginService, private exhibitorSvc: ExhitorsService, public dialog: MatDialog,
    private filtersService:FiltersService, private titleService:Title, private analyticsService: AnalyticsService, 
    private sharedService:SharedService) {

    this.first = true;//FIXME se usa para la primera carga del componente
    
    this.activatedRoute.paramMap.subscribe(params => {
      let productId = params.get('productId');
      if(productId!=this.productId && !this.first){
        this.productId = productId;
        this.ngOnInit();
      }
      this.productId = productId;
      this.first = false;
    });

    this.anonymousEmailAllowed = this.utilsService.parseBoolean(this.detailsService.getPropertyByKey('home.view.default'));
      this.eventName = this.activatedRoute.snapshot.paramMap.get('event') || null;

    }

  ngOnInit() {

    this.productDetail.productId = this.productId;
    this.productDetail.exhibitorId = this.exhibitorId;

    this.eventData = JSON.parse(this.sessionService.get('eventData', false) || '{}');
    
    this.catalogueService.getDataProperties().subscribe(data => {
      this.catalogueProperties = data;
    });
    
    let eventName = this.eventData?.eventName;
    this.catalogueId = this.eventData?.id;

    let getProductsDetailsIn = {
      productId: this.productId,
      projectionType: 'detail'
    };

    let getProductsImagesIn = {
      productId: this.productId,
      projectionType: 'detail'
    };

    let getProductsCategoriesIn = {
      productId: this.productId
    };

    let getFilesByCatalogueAndProductIn = {
      catalogueId: this.catalogueId,
      productId: this.productId
    };

    let getSocialNetworksByEventIn = {
      event: eventName
    };

    let getFavoriteResourcesIn = {
      event: eventName
    };

    let getExhibitorMainImageUrlIn = {
      exhibitorId: this.exhibitorId
    };

    this.getFavoriteResources(getFavoriteResourcesIn);
    this.getProductsDetails(getProductsDetailsIn);
    this.getProductsImages(getProductsImagesIn);
    this.getProductsCategories(getProductsCategoriesIn);
    this.getFilesByCatalogueAndProduct(getFilesByCatalogueAndProductIn);
    this.getSocialNetworksByEvent(getSocialNetworksByEventIn);


    this.prepareDataAndSendAnalytics();

    //if (this.images.length > 0) {
      //this.activeImage = this.images[0];
    //}
    
    this.sharedService.getIsMobile().subscribe(arg => this.mobile = arg);

    this.langChangeSubscription = this.translateService.onLangChange.subscribe(() => {
      this.products = this.sortProductsByCurrentLanguage([...this.products]);
    });
  }

  prepareDataAndSendAnalytics() {
      setTimeout(() => {
        this.products = this.products.map(product => ({
          ...product,
          exhibitorName: this.projection?.name,
          exhibitorId: this.exhibitorId,
          standLocation: this.projection?.standLocation
        }));
        if (this.products.length > 0) {
          this.analyticsService.sendViewItemList(this.products, 'product', 'detail');
        }
        console.log("prepareDataAndSendAnalytics", this.productsDetail, this.products);
        this.productWithExhibitorData = this.productsDetail;
        this.productWithExhibitorData['exhibitorName'] = this.projection?.name;
        this.productWithExhibitorData['standLocation'] = this.projection?.standLocation;
        this.analyticsService.sendViewItem(this.productWithExhibitorData, 'product', this.unifiedCategories);
      }, 1000);
  }

  updateExhibitorId(){

    let getPublishedProductsIn = {
      exhibitorId: this.exhibitorId
    };

    let getProjectionIn = {
      exhibitorId: this.exhibitorId,
      projection: 'forProductDetail'
    };

    let getExhibitorMainImageUrlIn = {
      exhibitorId: this.exhibitorId
    };

    this.getPublishedProducts(getPublishedProductsIn);
    this.getProjection(getProjectionIn);
    this.getExhibitorMainImageUrl(getExhibitorMainImageUrlIn);
    
    this.titleService.setTitle(this._api(this.productsDetail['translations'], 'name'));

  }

  setActiveImage(image) {
    this.activeImage = image;
  }

  setImage(url: string) {
    return url ? url : this.catalogueProperties.defaultProductImage  || 'assets/img/no_image_available.png';
  }

  setFavorite() {
    this.isFavorite = !this.isFavorite;
  }
  
  showEmailForm() {
    if (this.loginService.isAuth()) {
      this.openEmailModal();
    } else if (this.anonymousEmailAllowed && !this.loginService.isAuth()) {
      this.openEmailModal();
    } else {
      const modalRef = this.modalService.open(ModalLoginComponent);
      modalRef.result.then((result) => {
        this.openEmailModal();
      }, (reason) => {
        //console.log('Modal dismissed with:', reason);
      });
    }
  }

  openEmailModal() {

    if (this.loginService.isAuth()) {
      this.showEmailModal();
    }
    else{
      const modalRef = this.modalService.open(ModalLoginComponent);
      modalRef.result.then((result) => {
          this.showEmailModal();
      }, (reason) => {
        //console.log('Modal dismissed with:', reason);
      });
    }

  }

  
  showEmailModal() {

    const modalRef = this.modalService.open(EmailModalComponent, { size: 'lg' });
    modalRef.result.then(email => {
      var emailParams = {
        'to': this.exhibitorId,
        'name': email.name,
        'subject': email.subject,
        'text': email.text,
        'from': email.from,
        'captchaResponse': email.captchaResponse
      };
      this.filtersService.sendExpositorByVisitor(emailParams).subscribe(result => {
        console.log('successfully_sent');
        this.analyticsService.sendContact(this.projection?.countryId, this.projection?.zipCode);
        this.showDialog("MODAL_SIMPLE.SUCCESSFULLY_SENT");
      }, err => {
        if (err.status === 403) {
          console.log('permissionDenied');
          this.showDialog("MODAL_SIMPLE.PERMISSIONDENIED");
        } else {
          console.log('apiError000000');
          this.showDialog("MODAL_SIMPLE.APIERROR000000");
        }
        console.warn(err);
      });
    }).catch(error => {
      console.warn(error);
    });

  }

  showDialog(text:string): void {
    const modalRef = this.modalService.open(ModalSimpleComponent);
    modalRef.componentInstance.titleTranslation = 'MODAL_SIMPLE.TITLE_INFORMATION';
    modalRef.componentInstance.modalInformation = text;
    modalRef.componentInstance.isHtml = false;
  }

  openMapInNewTab() {
    const baseUri: string = ENV.MAPS.BASE_URI;
    let url: string = `${baseUri}?eventCode=${this.eventData.sapCode}&allowExternalLinks=true&language=${this.utilsService.mapLanguageCode(this.translateService.currentLang)}`;

    if (!this.utilsService.isEmpty(this.exhibitorId)) {
      url = `${url}&exhibitorId=${this.exhibitorId}&staticMap=true`;
    }

    window.open(url);
  
  }

  setExhibitorImage(url: string): string {
    return url ? url : this.catalogueProperties.defaultExhibitorImage || 'assets/img/no_image_available.png';
  }

  _api(transition, property){
    return this.utilsService._api(transition, property);
  }

  removeExtFromUrlFile(url: string): string {
    return '';
  }

  fixUrl(url: string): string {
    if (!/^https?:\/\//i.test(url)) {
      return 'http://' + url;
    }
    return url;
  }

  exhibitorHasSocialNetworks(exhibitor: any): boolean {
    return exhibitor && exhibitor.socialNetworks && exhibitor.socialNetworks.length > 0;
  }

  unifyCategories(categories) {
    for (let i = 0; i < categories.length; i++) {
      const exists = this.unifiedCategories.some(cat => cat.id === categories[i].id);
      if (!exists) {
        this.unifiedCategories.push(categories[i]);
      }
      if (categories[i].childHierarchicalProperties) {
        this.unifyCategories(categories[i].childHierarchicalProperties);
      }
    }
  }

  /** Llamadas */

  getPublishedProducts(getPublishedProductsIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.exhitorsService.getPublishedProducts(getPublishedProductsIn)
      .subscribe((data: object) => {
        this.getPublishedProductsOk(data);
      },
        error => {
          this.getPublishedProductsError(error);
        });

  }

  getPublishedProductsOk(data) {

    this.loader.count--;
    this.products = this.sortProductsByCurrentLanguage(data);
    this.products = this.products.filter(product => product.id !== parseInt(this.productId, 10));

  }

  sortProductsByCurrentLanguage(products: any[]): any[] {
    const currentLang = this.translateService.currentLang;

    return products.sort((a, b) => {
      const nameA = this.getTranslatedName(a.translations, currentLang);
      const nameB = this.getTranslatedName(b.translations, currentLang);
      return nameA.localeCompare(nameB, currentLang);
    });
  }

  getTranslatedName(translations: any[], lang: string): string {
    if (!translations || translations.length === 0) {
      return '';
    }

    const translation = translations.find(t => t.language && t.language.includes(lang));
    if (translation && translation.name) {
      return translation.name;
    }

    return translations[0]?.name || '';
  }

  getPublishedProductsError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }

  
  getProjection(getProjectionIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.exhitorsService.getProjection(getProjectionIn)
      .subscribe((data: object) => {
        this.getProjectionOk(data);
      },
        error => {
          this.getProjectionError(error);
        });

  }

  getProjectionOk(data) {
    this.loader.count--;
    this.projection = data;

  }

  getProjectionError(error) {
    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }


  getProductsDetails(getProductsDetailsIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.productsService.getProductsDetails(getProductsDetailsIn)
      .subscribe((data: object) => {
        this.getProductsDetailsOk(data);
      },
        error => {
          this.getProductsDetailsError(error);
        });

  }

  getProductsDetailsOk(data) {
    this.loader.count--;
    this.productsDetail = data;
    this.exhibitorId = data?.exhibitorId;
    this.updateExhibitorId();

  }

  getProductsDetailsError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }


  getProductsImages(getProductsImagesIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.productsService.getProductsImages(getProductsImagesIn)
      .subscribe((data: object) => {
        this.getProductsImagesOk(data);
      },
        error => {
          this.getProductsImagesError(error);
        });

  }

  getProductsImagesOk(data) {

    this.loader.count--;
    this.images = data._embedded.images;

    if (this.images.length < 1) {
      this.images[0] = {
        url: this.setExhibitorImage(''),
        id: 1
      }
    }
    
    if(this.images.length > 0)
      this.setActiveImage(this.images[0]);

  }

  getProductsImagesError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }



  getProductsCategories(getProductsCategoriesIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.productsService.getProductsCategories(getProductsCategoriesIn)
      .subscribe((data: object) => {
        this.getProductsCategoriesOk(data);
      },
        error => {
          this.getProductsCategoriesError(error);
        });

  }

  getProductsCategoriesOk(data) {

    this.loader.count--;
    this.productCategories = data;
    this.unifyCategories(data.masterProperties);

  }

  getProductsCategoriesError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }

  getHierarchicalProperties(getHierarchicalPropertiesIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.productsService.getHierarchicalProperties(getHierarchicalPropertiesIn)
      .subscribe((data: object) => {
        this.getHierarchicalPropertiesOk(data);
      },
        error => {
          this.getHierarchicalPropertiesError(error);
        });

  }

  getHierarchicalPropertiesOk(data) {

    this.loader.count--;
    this.hierarchicalProperties = data;
    this.unifyCategories(data);

  }

  getHierarchicalPropertiesError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }


  /** Fin Products */

  getFilesByCatalogueAndProduct(getFilesByCatalogueAndProductIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.catalogueService.getFilesByCatalogueAndProduct(getFilesByCatalogueAndProductIn)
      .subscribe((data: object) => {
        this.getFilesByCatalogueAndProductOk(data);
      },
        error => {
          this.getFilesByCatalogueAndProductError(error);
        });

  }

  getFilesByCatalogueAndProductOk(data) {

    this.loader.count--;
    this.files = data?._embedded?.files;

  }

  getFilesByCatalogueAndProductError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }


  getSocialNetworksByEvent(getSocialNetworksByEventIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.catalogueService.getSocialNetworksByEvent(getSocialNetworksByEventIn)
      .subscribe((data: object) => {
        this.getSocialNetworksByEventOk(data);
      },
        error => {
          this.getSocialNetworksByEventError(error);
        });

  }


  getSocialNetworksByEventOk(data) {

    this.loader.count--;
    this.socialNetworks = data;

  }

  getSocialNetworksByEventError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }


  getFavoriteResources(getFavoriteResourcesIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.catalogueService.getFavoriteResources(getFavoriteResourcesIn)
      .subscribe((data: object) => {
        this.getFavoriteResourcesOk(data);
      },
        error => {
          this.getFavoriteResourcesError(error);
        });

  }


  getFavoriteResourcesOk(data) {
    this.loader.count--;
    data.favoriteProducts.forEach(item => {
      if (item.idProduct.toString() === this.productId) {
        this.productDetail.isFavorite = true;
        this.productDetail.favoriteId = item.id;
        this.productDetail.note = item.note;
        this.productDetail.exhibitorId = item.idExhibitor;
      }
    });
  }

  getFavoriteResourcesError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }


  getExhibitorMainImageUrl(getExhibitorMainImageUrlIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.exhitorsService.getExhibitorMainImageUrl(getExhibitorMainImageUrlIn)
      .subscribe((data: object) => {
        this.getExhibitorMainImageUrlOk(data);
      },
        error => {
          this.getExhibitorMainImageUrlError(error);
        });

  }

  getExhibitorMainImageUrlOk(data) {

    this.loader.count--;
    this.imageUrl = data;

  }

  getExhibitorMainImageUrlError(error) {

    this.loader.count--;
    this.imageUrl = { data: this.setExhibitorImage('') };

  }

  goBack(): void {
    const searchConfig$ = this.searchService.getSearchConfig();
    const queryParams = { filter: searchConfig$.filter, lang: this.utilsService.mapLanguageCode(this.translateService.currentLang)};
    this.router.navigate([`${this.eventData?.eventName}/home`], {queryParams});
  }

  goExibitors(){
    this.analyticsService.sendSelectItem(this.projection, 'exhibitor', 'detail');
    const queryParams = { lang: this.utilsService.mapLanguageCode(this.translateService.currentLang)};
    this.router.navigate([`${this.catalogueId}/${this.eventData.eventName}/${'exhibitor'}/${this.projection?.id}/detail`], {queryParams});
  }

  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
    if (this.langChangeSubscription) {
      this.langChangeSubscription.unsubscribe();
    }
  }


}
